<section *ngIf="status" class="resource-status flex align-items-center justify-content-center p-3" aria-live="polite">
  <div class="card w-full text-center flex flex-column align-items-center gap-3 p-4 md:p-5">
    <ng-container *ngIf="status !== 'retry'">
      <div class="resource-status__sign border-round-lg surface-100 border-2 border-primary px-5 py-3" aria-hidden="true">
        <i class="pi pi-car text-primary text-3xl mb-2"></i>
        <div class="text-6xl font-bold text-color">{{ status }}</div>
      </div>
    </ng-container>
    <h1 class="text-2xl md:text-3xl m-0">{{ ('shared.resource_page.' + status + '.title') | translate }}</h1>
    <p class="text-color-secondary line-height-3 m-0">{{ ('shared.resource_page.' + status + '.description') | translate }}</p>
    <button *ngIf="status === 'retry'" pButton type="button" icon="pi pi-refresh"
      [label]="'shared.resource_page.try_again' | translate" (click)="retry.emit()"></button>
    <a *ngIf="status !== 'retry'" pButton [routerLink]="['/']" icon="pi pi-home"
      [label]="'shared.resource_page.home' | translate"></a>
  </div>
</section>
